
<template>
  <div>
    <iframe
      :src="userPageUrl"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>


<script>
import api from "@/api/projectApi";
import {siteMixins} from "@/mixins/tabChang";
import store from "@/store";
import request from "@/router/axios";

export default {
  name: 'complaintDetailReport',

  data() {
    return {
      props: {multiple: true},
      userPageUrl:"",

    }
  },
  created() {
    this.doTobb();
    window.close()
  },

  mounted() {

  },

  methods: {
    doTobb(){
      this.$http({
        url: "/basic/soOrderDispatch/getOtherIndex",
        method: 'post',
      }).then(res => {
        this.userPageUrl = "http://dw.sc.5mall.com/web1/#/report/vform/out_render?reportCode=231218&dw="+res.data.data
        // window.open("http://dw.sc.5mall.com/web1/#/report/vform/out_render?reportCode=231218&dw="+res.data.data)
      })


    },
    }

};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
